module.exports = __webpack_public_path__ + "img/cert_07.4b6fbac3.jpg";